import fallbackbanner from '@/assets/images/fallbackbanner.png';
import { getCdnUrl } from '@/helpers';
import { INSTITUCIONAL_BANNER } from '@/settings';

import OfferContainer from '../Container';

const Institucional = () => {
  return (
    <OfferContainer
      image={<img src={getCdnUrl(INSTITUCIONAL_BANNER, fallbackbanner)} alt='Imagem do banner institucional' />}
    />
  );
};
export default Institucional;
